import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ImportExportService } from 'src/app/client-management/import-export';
import { NewImportExportService } from '../../../_service/new-import-export.service';
import { Subscription } from 'rxjs';
import { ReportAuto } from 'src/app/client-management/data-management';
import { ToastrService } from 'ngx-toastr';
import { AutoSendDeleteComponent } from '../auto-send-delete/auto-send-delete.component';

interface AutoSendItem {
  id: number;
  emails: string;
  period: string;
  title: string;
  url?: string;
  payload?: string;
  signinUrl?: string;
}

@Component({
  selector: 'app-auto-send-list',
  templateUrl: './auto-send-list.component.html',
  styleUrls: ['./auto-send-list.component.css']
})
export class AutoSendListComponent implements OnInit {

  items: AutoSendItem[] = [];

  editingId: number | null = null;
  editModel: ReportAuto = new ReportAuto();

  rapportList: any[] = [];
  rapportListSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<AutoSendListComponent>,
    private service: ImportExportService,
    private importExportService: NewImportExportService,
        private toastr: ToastrService,
        private dialog:MatDialog
    
  ) { }

  ngOnInit(): void {
    this.rapportListSubscription = this.importExportService.getRapportsSend().subscribe((rapports) => {
      this.rapportList = rapports;
      this.items = rapports;
    });

    if (!this.importExportService.isRapportsLoaded()) {
    this.loadAllReports();
  }
  }

  loadAllReports() {
    this.service.getAllReportSent().subscribe(
      (reportAutos) => {
        this.importExportService.setRapportSend(reportAutos);
      },
      (error) => {
        this.toastr.error('Probleme est survenu lors du chargements !', 'Erreur');
      }
    );
  }

  // Sépare la string "email1;email2" en tableau pour l'affichage
  getEmailsList(item: AutoSendItem): string[] {
    return item.emails ? item.emails.split(';').map(e => e.trim()).filter(e => !!e) : [];
  }

  onEdit(item: any): void {
    this.editingId = item.id;
    this.editModel = { ...item };
  }

  onCancelEdit(): void {
    this.editingId = null;
  }

  onValidate(item: AutoSendItem): void {
    item.title = this.editModel.title;
    item.emails = this.editModel.emails;
    item.period = this.editModel.period;
    this.editingId = null;
    let updateItem:ReportAuto={
      id:this.editModel.id,
      title:this.editModel.title,
      emails:this.editModel.emails,
      period:this.editModel.period,
      url:this.editModel.url,
      payload:this.editModel.payload,
      signinUrl:this.editModel.signinUrl
    }
    
    this.service.update(updateItem).subscribe(
      (updatedItem) => {
        this.importExportService.updateRapport(updatedItem);
        this.toastr.success('Rapport Automatique bien modifie !');

      },
      (error) => {
        this.toastr.error('Veuillez contacter votre administrateur !');

      }
    );
  }

  onDelete(item: AutoSendItem): void {
    this.dialog.open(AutoSendDeleteComponent, {
      width: '350px',
      data: { rapport: item }
    });
  }

}